import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatBeijingDateTime } from "../utils/datetime";

export default function ChatListPage() {
  const navigate = useNavigate();
  const currentUserId = Number(localStorage.getItem("user_id"));
  const [chatList, setChatList] = useState([]);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
  const loadChatList = async () => {
    try {
      const res = await fetch(
        `/api/chat-list?current_user_id=${currentUserId}`
      );
      const data = await res.json();

      if (Array.isArray(data)) {
        setChatList(data);
      } else {
        setChatList([]);
      }
    } catch (err) {
      console.error("加载聊天列表失败:", err);
      setChatList([]);
    } finally {
      setLoading(false);
    }
  };

  if (!currentUserId) {
    navigate("/login");
    return;
  }

  loadChatList();
  window.addEventListener("unreadUpdated", loadChatList);

  return () => {
    window.removeEventListener("unreadUpdated", loadChatList);
  };
}, [currentUserId, navigate]);


  const formatTime = (time) => formatBeijingDateTime(time);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 px-4 py-8">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow overflow-hidden">
        <div className="p-4 text-xl font-bold border-b">消息列表</div>

        {loading ? (
          <div className="text-center text-gray-400 py-10">加载中...</div>
        ) : chatList.length === 0 ? (
          <div className="text-center text-gray-400 py-10">还没有聊天记录</div>
        ) : (
          <div>
            {chatList.map((item) => (
              <div
                key={item.user_id}
                onClick={() =>
                  navigate("/chat", {
                    state: {
                      user: {
                        id: item.user_id,
                        name: item.name,
                      },
                    },
                  })
                }
                className="flex items-center gap-3 p-4 border-b cursor-pointer hover:bg-pink-50 transition"
              >
                <img
                  src={
                    item.avatar
                      ? `${item.avatar}`
                      : "https://via.placeholder.com/48"
                  }
                  alt={item.name}
                  className="w-12 h-12 rounded-full object-cover"
                />

                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-center">
                    <p className="font-semibold truncate">{item.name}</p>

                    <div className="flex items-center gap-2 ml-3">
                      <span className="text-xs text-gray-400 whitespace-nowrap">
                        {formatTime(item.last_time)}
                      </span>

                      {item.unread_count > 0 && (
                        <span className="min-w-[22px] h-5 px-1 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                          {item.unread_count > 99 ? "99+" : item.unread_count}
                        </span>
                      )}
                    </div>
                  </div>

                  <p className="text-sm text-gray-500 truncate mt-1">
                    {item.last_message}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
